import type { AutoGeneratorForFormModel } from "@/components/features/_model";

import type { HotelPolicyZodSchemaType } from "./validation-schema";

const _excludeKeys = [] as const;
export const excludeKeys = _excludeKeys.map((key) => key);
export type ExcludeKeys = (typeof excludeKeys)[number];

export type AccommodationHotelPolicyFormModel = AutoGeneratorForFormModel<
	HotelPolicyZodSchemaType,
	ExcludeKeys,
	QueryData
>;

export type QueryData = {
	hotel: {
		hotelEmailAddress: string;
	};
	planList: { planID: string; inSale: boolean; name: string }[];
	hotelDisplaySettings: {
		id: string;
		hotelID: string;
	};
	isCreditCardRegistered: boolean;
};
